import { useTranslation } from 'react-i18next'

const VERSION = '0.0.1'
const BUILD_SHA = (import.meta.env.VITE_BUILD_SHA as string | undefined) ?? 'dev'

export function Footer() {
  const { t } = useTranslation()

  return (
    <div className="foot">
      <div>
        v{VERSION} · <code>{BUILD_SHA}</code>
      </div>
      <div>
        <a href="#">{t('lobby.footer.privacy')}</a>
        <span className="foot__dot">·</span>
        <a href="#">{t('lobby.footer.terms')}</a>
        <span className="foot__dot">·</span>
        <a href="#">{t('lobby.footer.contact')}</a>
      </div>
    </div>
  )
}
